//
// Module for the Death Setup wizard's Initiate step
//
rs.module("participant/benefit/setup/death/wizard/initiatestep",

    [
        "controls/components/event-banner",
        "common/select-helper"
    ],

    function (eventBanner, selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, backendUrls) {

            // Get the wizard's next button
            var wizardNextButton = $(`[data-wizard]`).js("_next");

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);
            var initiateOnlyCheckBox = stepContainer.js(jsSelectors.initiateOnlyCheckBox, { required: false });
            var sourceBenefitSelect = stepContainer.js(jsSelectors.sourceBenefitSelect, { required: false });
            var sourceBenefitSelectHelper = selectHelper.getHelper(sourceBenefitSelect);
            var benefitTypeSelect = stepContainer.js(jsSelectors.benefitTypeSelect, { required: false });
            var benefitTypeSelectHelper = selectHelper.getHelper(benefitTypeSelect);
            var recipientsContainer = stepContainer.js(jsSelectors.recipientsContainer, { required: false });
            var recipientsGridContainer = stepContainer.js(jsSelectors.recipientsGridContainer, { required: false });
            var basisPlanSelect = stepContainer.js(jsSelectors.basisPlanSelect, { required: false });
            var splitPlanCalculationCheckBox = stepContainer.js(jsSelectors.splitPlanCalculationCheckBox, { required: false });
            var separationTypeInput = stepContainer.js(jsSelectors.separationTypeInput, { required: false });
            var separationSubTypeInput = stepContainer.js(jsSelectors.separationSubTypeInput, { required: false });
            var sourceBenefitContainer = stepContainer.js(jsSelectors.sourceBenefitContainer, { required: false });

            // On initialize of page, appropriately set wizard's next button text (Next or Finish)
            setWizardNextButtonText();

            // Hookup benefitTypeSelect change event
            benefitTypeSelect.change(benefitTypeChange);
            basisPlanSelect.change(basisPlanChange);

            // Conditionally set display of Wizard's next button text (Next or Finish) based on InitiateOnlyCheckBox
            function setWizardNextButtonText() {

                // Get the Next button's HTML (contains text and spinner icon)
                var buttonHtml = wizardNextButton.html();

                // Conditionally update text portion of button's HTML based on initiateOnlyCheckBox
                if (initiateOnlyCheckBox.is(":checked")) {
                    wizardNextButton.html(buttonHtml.replace('Next', 'Finish'));
                }
                else {
                    wizardNextButton.html(buttonHtml.replace('Finish', 'Next'));
                }
            }

            // Handle initiateOnlyCheckBox change
            initiateOnlyCheckBox.change(function () {

                // Set wizard's next button text (Next or Finish)
                setWizardNextButtonText();
            });

            // Benefit Type change event
            function benefitTypeChange() {

                eventBanner.removeAllMessages();

                // Get selected Benefit Type
                var selectedBenefitType = benefitTypeSelect.val();

                // Get selected Source Benefit
                var selectedSourceBenefitKey = sourceBenefitSelect.val();

                $.get(backendUrls.getRecipientsGrid,
                    {
                        benefitType: selectedBenefitType,
                        sourceBenefitKey: selectedSourceBenefitKey
                    })
                    .done(function (html) {
                        recipientsGridContainer.html(html);
                        recipientsContainer.show();
                    })
                    .fail(function () {
                        recipientsContainer.hide();
                    });         
            }

            // Basis Plan change event
            function basisPlanChange() {
                eventBanner.removeAllMessages();

                var selectedBasisPlanKey = basisPlanSelect.val();

                $.get(backendUrls.updateBasisPlan, {
                    basisPlanKey: selectedBasisPlanKey
                })
                .done(function (response) {

                    // Update Separation Types
                    if (response.separationType) {
                        separationTypeInput.val(response.separationType);
                    }
                    if (response.separationSubType) {
                        separationSubTypeInput.val(response.separationSubType);
                    }

                    // Update Source Benefits
                    if (response.sourceBenefits?.length > 0) {
                        sourceBenefitContainer.show();
                        sourceBenefitSelectHelper.clearOptions();
                        sourceBenefitSelectHelper.replaceOptions(response.sourceBenefits, { withBlank: false });
                    } else {
                        sourceBenefitSelectHelper.clearOptions();
                        sourceBenefitContainer.hide();
                    }

                    // Update Available Benefits
                    if (response.availableBenefits?.length > 0) {
                        benefitTypeSelectHelper.clearOptions();
                        benefitTypeSelectHelper.replaceOptions(response.availableBenefits, { withBlank: true });
                    } else {
                        benefitTypeSelectHelper.clearOptions();
                    }

                    // Update Split Plan flag
                    if (response.splitPlanCalculation !== undefined) {
                        if (response.splitPlanCalculation) {
                            splitPlanCalculationCheckBox.setDisabled(false);
                            splitPlanCalculationCheckBox.setChecked(true).clearErrors();
                        }
                        else {
                            splitPlanCalculationCheckBox.setChecked(false).clearErrors();
                            splitPlanCalculationCheckBox.setDisabled(true);
                        }
                    }
                })
                .fail(function () {
                    console.log("Error updating Basis Plan.");
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);